var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgLinePattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 739,
    height: 431
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 12",
    transform: "translate(-5183.767 -4377)",
    clipPath: "url(#img-line-pattern_svg__clip-path)",
    fill: "none",
    stroke: "#690"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "M5445.397 3946.679l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "M5451.023 3949.498l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 19",
    d: "M5456.65 3952.318l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 20",
    d: "M5462.274 3955.137l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    d: "M5467.9 3957.956l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 22",
    d: "M5473.525 3960.775l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 23",
    d: "M5479.151 3963.594l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    d: "M5484.776 3966.414l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    d: "M5490.402 3969.233l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M5496.028 3972.052l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    d: "M5501.653 3974.87l-546.36 891.177",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 28",
    d: "M5507.278 3977.69l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 29",
    d: "M5512.904 3980.51l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 30",
    d: "M5518.53 3983.329l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 31",
    d: "M5524.155 3986.148l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 32",
    d: "M5529.781 3988.968l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 33",
    d: "M5535.407 3991.787l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 34",
    d: "M5541.031 3994.606l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 35",
    d: "M5546.657 3997.425l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 36",
    d: "M5552.283 4000.245l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 37",
    d: "M5557.908 4003.064l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 38",
    d: "M5563.534 4005.883l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    d: "M5569.16 4008.702l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    d: "M5574.785 4011.522l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    d: "M5580.41 4014.34l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 42",
    d: "M5586.036 4017.16l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 43",
    d: "M5591.662 4019.979l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    d: "M5597.287 4022.799l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 45",
    d: "M5602.912 4025.618l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 46",
    d: "M5608.538 4028.437l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 47",
    d: "M5614.163 4031.257l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 48",
    d: "M5619.79 4034.076l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 49",
    d: "M5625.414 4036.895l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 50",
    d: "M5631.04 4039.714l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 51",
    d: "M5636.665 4042.533l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 52",
    d: "M5642.291 4045.353l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 53",
    d: "M5647.917 4048.172l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 54",
    d: "M5653.542 4050.99l-546.36 891.177",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 55",
    d: "M5659.168 4053.81l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 56",
    d: "M5664.793 4056.63l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 57",
    d: "M5670.42 4059.449l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 58",
    d: "M5676.044 4062.268l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 59",
    d: "M5681.67 4065.087l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 60",
    d: "M5687.295 4067.907l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 61",
    d: "M5692.921 4070.726l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 62",
    d: "M5698.546 4073.545l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 63",
    d: "M5704.172 4076.364l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 64",
    d: "M5709.797 4079.184l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 65",
    d: "M5715.423 4082.003l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 66",
    d: "M5721.05 4084.822l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 67",
    d: "M5726.674 4087.64l-546.36 891.177",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 68",
    d: "M5732.3 4090.46l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 69",
    d: "M5737.925 4093.28l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 70",
    d: "M5743.551 4096.099l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 71",
    d: "M5749.176 4098.919l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 72",
    d: "M5754.802 4101.737l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 73",
    d: "M5760.428 4104.557l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 74",
    d: "M5766.053 4107.376l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 75",
    d: "M5771.678 4110.195l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 76",
    d: "M5777.304 4113.015l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 77",
    d: "M5782.93 4115.834l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 78",
    d: "M5788.555 4118.653l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 79",
    d: "M5794.18 4121.472l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 80",
    d: "M5799.806 4124.292l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 81",
    d: "M5805.431 4127.11l-546.36 891.177",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 82",
    d: "M5811.057 4129.93l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 83",
    d: "M5816.683 4132.749l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 84",
    d: "M5822.308 4135.569l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 85",
    d: "M5827.933 4138.388l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 86",
    d: "M5833.56 4141.207l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 87",
    d: "M5839.184 4144.027l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 88",
    d: "M5844.81 4146.846l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 89",
    d: "M5850.435 4149.665l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 90",
    d: "M5856.061 4152.484l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 91",
    d: "M5861.686 4155.303l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 92",
    d: "M5867.312 4158.123l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 93",
    d: "M5872.937 4160.942l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 94",
    d: "M5878.563 4163.76l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 95",
    d: "M5884.19 4166.58l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 96",
    d: "M5889.814 4169.4l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 97",
    d: "M5895.44 4172.219l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 98",
    d: "M5901.065 4175.038l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 99",
    d: "M5906.691 4177.857l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 100",
    d: "M5912.316 4180.677l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 101",
    d: "M5917.942 4183.496l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 102",
    d: "M5923.567 4186.315l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 103",
    d: "M5929.193 4189.134l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 104",
    d: "M5934.82 4191.953l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 105",
    d: "M5940.444 4194.773l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 106",
    d: "M5946.07 4197.592l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 107",
    d: "M5951.695 4200.41l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 108",
    d: "M5957.32 4203.23l-546.36 891.177",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 109",
    d: "M5962.946 4206.05l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 110",
    d: "M5968.572 4208.869l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 111",
    d: "M5974.197 4211.688l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 112",
    d: "M5979.823 4214.508l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 113",
    d: "M5985.448 4217.327l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 114",
    d: "M5991.074 4220.146l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 115",
    d: "M5996.7 4222.966l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 116",
    d: "M6002.325 4225.784l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 117",
    d: "M6007.951 4228.604l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 118",
    d: "M6013.576 4231.423l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 119",
    d: "M6019.201 4234.242l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 120",
    d: "M6024.827 4237.062l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 121",
    d: "M6030.453 4239.88l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 122",
    d: "M6036.078 4242.7l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 123",
    d: "M6041.704 4245.519l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 124",
    d: "M6047.33 4248.339l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 125",
    d: "M6052.954 4251.158l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 126",
    d: "M6058.58 4253.977l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 127",
    d: "M6064.205 4256.797l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 128",
    d: "M6069.831 4259.615l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 129",
    d: "M6075.456 4262.435l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 130",
    d: "M6081.082 4265.254l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 131",
    d: "M6086.707 4268.073l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 132",
    d: "M6092.333 4270.893l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 133",
    d: "M6097.958 4273.712l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 134",
    d: "M6103.584 4276.53l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 135",
    d: "M6109.21 4279.35l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 136",
    d: "M6114.835 4282.17l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 137",
    d: "M6120.461 4284.989l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 138",
    d: "M6126.086 4287.808l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 139",
    d: "M6131.712 4290.628l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 140",
    d: "M6137.337 4293.446l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 141",
    d: "M6142.963 4296.266l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 142",
    d: "M6148.588 4299.085l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 143",
    d: "M6154.214 4301.904l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 144",
    d: "M6159.84 4304.724l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 145",
    d: "M6165.465 4307.543l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 146",
    d: "M6171.091 4310.362l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 147",
    d: "M6176.716 4313.18l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 148",
    d: "M6182.342 4316l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 149",
    d: "M6187.967 4318.82l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 150",
    d: "M6193.593 4321.639l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 151",
    d: "M6199.218 4324.458l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 152",
    d: "M6204.844 4327.278l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 153",
    d: "M6210.47 4330.097l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 154",
    d: "M6216.095 4332.916l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 155",
    d: "M6221.72 4335.735l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 156",
    d: "M6227.346 4338.554l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 157",
    d: "M6232.972 4341.374l-546.36 891.176",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 158",
    d: "M6238.597 4344.193l-546.36 891.175",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 159",
    d: "M6244.222 4347.012l-546.36 891.176",
    strokeWidth: 1.00042
  }))));
}

export default __webpack_public_path__ + "8a67b137a847aea077c8e5a598fc164e.svg";
export { SvgImgLinePattern as ReactComponent };